<template>
  <section>
    <b-modal
      :visible="visible"
      hide-footer
      button-size="sm"
      size="xl"
      modal-cancel="false"
      no-close-on-backdrop
      @close="close"
      id="registered-student-list"
    >
      <template v-slot:modal-title>Lista de estudiantes</template>
      <section class="container-fluid">
        <template v-if="courseOffered !== null">
          <div class="row">
            <div class="col-12 col-xl-5">
              <b>Course:</b> {{ courseOffered.course_name }}
            </div>
            <div class="col-12 col-xl-6">
              <b>Term: </b>{{ courseOffered.period | period }}
              &nbsp;&nbsp;&nbsp;
              <b>Year: </b>
              {{ courseOffered.courses_offered_year }}
            </div>
            <div
              class="col-12 col-xl-1 float-right"
              v-auth-roles="{
                user: userAuth,
                roles: [roles.ROLE_SECRETARY, roles.ROLE_ADMINISTRATOR],
              }"
            >
              <button
                class="btn btn-secondary btn-sm"
                title="Descargar reporte"
                @click="excel()"
              >
                <span><CIcon size="sm" name="cil-print" /></span>
              </button>
            </div>
          </div>
          <div class="row mb-1">
            <div
              class="col-12 col-xl"
              v-auth-roles="{
                user: userAuth,
                roles: [roles.ROLE_SECRETARY, roles.ROLE_ADMINISTRATOR],
              }"
            >
              <b>Teacher: </b
              >{{
                courseOffered.person_fullname !== " "
                  ? courseOffered.person_fullname
                  : "--Not assigned--"
              }}
            </div>
            <div class="col-12 col-xl">
              <b>Schedule: </b>
              <span style="white-space: pre">{{
                courseOffered | time_courses_offered
              }}</span>
            </div>
            <div class="col-6 col-xl">
              <b>Parallel: </b>
              <span>{{ courseOffered.parallel }}</span>
            </div>
            <div class="col-6 col-xl">
              <b>Classroom: </b>
              <span>{{ courseOffered.classroom }}</span>
            </div>
          </div>
        </template>
        <CDataTable
          class="table-bordered c-table c-table-main"
          :hover="true"
          :striped="true"
          :bordered="true"
          :small="true"
          :items="items"
          :fields="fields"
          :sorter="{ external: true, resetable: true }"
          @update:sorter-value="filterTable"
          :columnFilter="{ external: true, lazy: true }"
          @update:column-filter-value="filterTable"
          :column-filter-value.sync="columnFilter"
          :loading="loading"
        >
          <template #no-items-view>
            <div class="no-items-view">
              {{
                loading
                  ? "Cargando datos..."
                  : "No existen estudiantes registrados"
              }}
              <CIcon name="cil-ban" size="xl" v-if="!loading"></CIcon>
            </div>
          </template>
          <!-- filters -->

          <!-- data -->
          <template #id="{ index }">
            <td>{{ index + 1 }}</td>
          </template>
          <template #student_mobile="{ item }">
            <td>{{ item.student_mobile ? item.student_mobile : "" }}</td>
          </template>

          <template #student_phone="{ item }">
            <td>{{ item.student_phone ? item.student_phone : "" }}</td>
          </template>

          <template #student_email="{ item }">
            <td>{{ item.student_email ? item.student_email : "" }}</td>
          </template>

          <template #student_occupation="{ item }">
            <td>
              {{ item.student_occupation ? item.student_occupation : "" }}
            </td>
          </template>
          <template #sale_id="{ item }">
            <td style="text-align: center">
              <div v-if="item.tuition_price > 0">
                <span class="badge bg-success" v-if="item.paid == true"
                  >Pagada</span
                >
                <span class="badge bg-danger" v-else>No Pagada</span>
              </div>
            </td>
          </template>

          <template #detail="{ item }">
            <td>
              <b-button-group size="xs">
                <b-button
                  v-auth-roles="{
                    user: userAuth,
                    roles: [roles.ROLE_ADMINISTRATOR, roles.ROLE_TEACHER],
                  }"
                  v-if="item.grade_id == 0"
                  variant="success"
                  title="Subir nota"
                  @click="modalGradeAdd(item.id, item.student_id)"
                >
                  <CIcon size="sm" name="cil-note-add" />
                </b-button>
                <b-button
                  v-auth-roles="{
                    user: userAuth,
                    roles: [roles.ROLE_ADMINISTRATOR, roles.ROLE_TEACHER],
                  }"
                  v-if="item.grade_id !== 0"
                  variant="warning"
                  title="Modificar nota "
                  @click="
                    modalGradeEdit(item.id, item.grade_id, item.student_id)
                  "
                >
                  <CIcon size="sm" name="cil-note-add" />
                </b-button>
                <!-- annulled -->
                <b-button
                  v-auth-roles="{
                    user: userAuth,
                    roles: [roles.ROLE_ADMINISTRATOR],
                  }"
                  v-if="item.grade_id !== 0"
                  @click="modalDeleteGrade(item.grade_id, item.student_fullname)"
                  variant="danger"
                  title="Eliminar nota"
                >
                  <CIcon size="sm" name="cil-x-circle" />
                </b-button>
              </b-button-group>
            </td>
          </template>
        </CDataTable>
      </section>
    </b-modal>
    <section v-if="modShowAddGrade">
      <GradeAddModal
        :id_student="student_id"
        :course_offered_id="course_offered_id"
        :registration_id="registration_id"
        :modShowAddGrade="modShowAddGrade"
        @gradeAddModal="afterGradeAddModal"
      ></GradeAddModal>
    </section>
    <section v-if="modShowEditGrade">
      <GradeEditModal
        :id_student="student_id"
        :registration_id="registration_id"
        :grade_id="grade_id"
        :modShowEditGrade="modShowEditGrade"
        @gradeEditModal="afterGradeEditModal"
      ></GradeEditModal>
    </section>
    <section v-if="modShowGradeDelete">
      <GradeDeleteModal
        :grade_id="grade_id"
        :student_fullname="student_fullname"
        :modShowGradeDelete="modShowGradeDelete"
        @GradeDeleteModal="setGradeDeleteItem"
      ></GradeDeleteModal>
    </section>
  </section>
</template>
<script>
import { BAlert, BModal, BButton, BButtonGroup } from "bootstrap-vue";

import TableRecords from "@/components/shared/TableRecords";
import { Utils } from "@/plugins/utils";
import Constants from "@/plugins/constants";
// services
import Registrations from "@/plugins/services/registrations";
import CoursesOffered from "@/plugins/services/courses-offered";
//components
import GradeAddModal from "@/entities/grades/GradeAddModal";
import GradeEditModal from "@/entities/grades/GradeEditModal";
import GradeDeleteModal from "@/entities/grades/GradeDeleteModal";

export default {
  name: "RegisteredStudentsListModal",
  components: {
    BAlert,
    BModal,
    BButton,
    BButtonGroup,
    TableRecords,
    GradeAddModal,
    GradeEditModal,
    GradeDeleteModal,
  },
  props: {
    modShowRegisteredStudentList: { type: Boolean, required: true },
    course_offered_id: { type: Number, required: true },
  },
  data() {
    return {
      fields: [
        {
          key: "id",
          label: "#",
          sorter: false,
          filter: false,
          _style: "width: 8px;",
        },
        {
          key: "student_fullname",
          label: "Name",
          sorter: false,
          filter: false,
        },
        {
          key: "student_document_number",
          label: "C.I.",
          sorter: false,
          filter: false,
          _style: "width: 5%;",
        },
        {
          key: "student_phone",
          label: "Phone",
          sorter: false,
          filter: false,
          _style: "width: 5%;",
        },
        {
          key: "student_mobile",
          label: "Mobile",
          sorter: false,
          filter: false,
          _style: "width: 5%;",
        },
        {
          key: "grade_absence",
          label: "Nro Abs",
          sorter: false,
          filter: false,
          _style: "width: 5%;",
        },
        {
          key: "grade_permission",
          label: "Nro Prm",
          sorter: false,
          filter: false,
          _style: "width: 5%;",
        },
        {
          key: "grade_attendence",
          label: "Att",
          sorter: false,
          filter: false,
          _style: "width: 5%;",
        },
        {
          key: "grade_works",
          label: "Works",
          sorter: false,
          filter: false,
          _style: "width: 5%;",
        },
        {
          key: "grade_class_participation",
          label: "CP",
          sorter: false,
          filter: false,
          _style: "width: 5%;",
        },
        {
          key: "grade_quizes",
          label: "Qs",
          sorter: false,
          filter: false,
          _style: "width: 5%;",
        },
        {
          key: "grade_final_test",
          label: "FT",
          sorter: false,
          filter: false,
          _style: "width: 5%;",
        },
        {
          key: "grade_final_grade",
          label: "FG",
          sorter: false,
          filter: false,
          _style: "width: 5%;",
        },
        {
          key: "grade_observations",
          label: "Observation",
          sorter: false,
          filter: false,
          _style: "width: 10%;",
        },
        {
          key: "sale_id",
          label: "Payment",
          sorter: false,
          filter: false,
          _style: "width: 5%;",
        },
        {
          key: "detail",
          label: "Detail",
          sorter: false,
          filter: false,
          _style: "width: 5%;",
        },
      ],
      items: [],
      courseOffered: null,
      roles: Constants.roles,
      columnFilter: {
        column: "student_fullname",
        annulled: false,
        asc: true,
        enabled: true,
        pagination: false,
      },
      loading: true,
      dataEmit: { modalShow: false, data: null },
      modShowAddGrade: false,
      modShowEditGrade: false,
      registration_id: 0,
      grade_id: 0,
      student_id: 0,
      student_fullname:'',
      modShowGradeDelete:false,
    };
  },
  mounted() {
    this.columnFilter.course_offered_id = this.course_offered_id;
    this.getCourseOffered(this.course_offered_id);
    this.getAll(this.columnFilter);
  },
  computed: {
    userAuth() {
      return this.$store.state.userAuth;
    },
    visible() {
      return this.modShowRegisteredStudentList;
    },
  },
  methods: {
    getCourseOffered(id) {
      CoursesOffered.getOne(id)
        .then((res) => {
          this.courseOffered = res.data;
        })
        .catch((err) => {
          if (err.response && err.response.status == 404) {
            Utils.setFlash("danger", "Curso ofertado no encontrado.");
            this.closeModal();
          }
          if (err.response && err.response.status == 500) {
            Utils.setFlash("danger", "Error de servidor.");
            this.closeModal();
          }
          this.dataLoader = false;
        });
    },
    getAll(q = null, page = null) {
      this.loading = true;
      Registrations.allWithGrades(q, this.limit, page).then((res) => {
        this.loading = false;
        this.items = res.data;
      });
    },
    updateTable(page) {
      this.getAll(this.columnFilter, page);
    },
    filterTable(columnFilter) {
      this.columnFilter = { ...this.columnFilter, ...columnFilter };
      this.getAll(this.columnFilter);
    },
    clean() {
      this.columnFilter = {
        column: "student_fullname",
        annulled: false,
        asc: true,
        enabled: true,
        pagination: false,
      };
      this.getAll(this.columnFilter);
    },
    reload() {
      this.getAll(this.columnFilter);
    },
    modalGradeAdd(id, student_id) {
      this.registration_id = id;
      this.student_id = student_id;
      this.modShowAddGrade = true;
    },
    afterGradeAddModal(response) {
      if (
        response.data != null ||
        response.status == 404 ||
        response.status == 500
      ) {
        this.reload();
      }
      this.modShowAddGrade = response.modalShow;
    },
    modalGradeEdit(id, grade_id, student_id) {
      this.registration_id = id;
      this.grade_id = grade_id;
      this.student_id = student_id;
      this.modShowEditGrade = true;
    },
    afterGradeEditModal(response) {
      if (
        response.data != null ||
        response.status == 404 ||
        response.status == 500
      ) {
        this.reload();
      }
      this.modShowEditGrade = response.modalShow;
    },
    modalDeleteGrade(id,student_fullname) {
      this.modShowGradeDelete = true;
      this.grade_id = id;
      this.student_fullname=student_fullname
    },
    setGradeDeleteItem(response) {
      if (
        response.data != null ||
        response.status == 404 ||
        response.status == 500
      ) {
        this.reload();
      }
      this.modShowGradeDelete = response.modalShow;
    },
    excel() {
      let teacherSchedule = `${process.env.MIX_APP_API_ENDPOINT}/registrations/student-list-excel/${this.course_offered_id}`;
      window.open(teacherSchedule, "_blank");
    },
    closeModal(data = null) {
      this.dataEmit.modalShow = false;
      this.dataEmit.data = data;
      this.$emit("registeredStudentsListModal", this.dataEmit);
    },
    close() {
      this.closeModal();
    },
  },
};
</script>
